import styled from 'styled-components';

const SortingArrowStyled = styled.div`
  padding: 5px 4px 0;

  cursor: pointer;
`;

export { SortingArrowStyled };
